import { memo } from 'react'
import { TinyButton } from './styles'
import { STORAGE_KEY_MOCK, STORAGE_VALUE_MOCK } from '../../constants/mock'

export const SwitchMock = memo(() => {
  const mock = localStorage.getItem(STORAGE_KEY_MOCK)

  const switchMock = () => {
    if (mock === STORAGE_VALUE_MOCK) {
      localStorage.removeItem(STORAGE_KEY_MOCK)
    } else {
      localStorage.setItem(STORAGE_KEY_MOCK, STORAGE_VALUE_MOCK)
    }
  }

  const isMock = mock === STORAGE_VALUE_MOCK

  return (
    <TinyButton onClick={switchMock}>
      {isMock ? 'Disable' : 'Enable'} Mock
    </TinyButton>
  )
})
